import React, { Dispatch } from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { ChooseProducts } from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/ProductsTab/ChooseProducts";

import {
  CreateOrModifySubscriptionReducerType,
  CreateSubscriptionReducerAction,
} from "../subscriptionReducer";

interface ProductTabProps {
  index: number;
  payload: CreateOrModifySubscriptionReducerType;
  dispatchPayload: Dispatch<CreateSubscriptionReducerAction>;
  setPhase?: Dispatch<CreateSubscriptionReducerAction>;
}
export const ProductsTab = ({
  index,
  payload,
  dispatchPayload,
  setPhase,
}: ProductTabProps) => {
  return (
    <Grid container direction={"column"} rowSpacing={2} mt={2}>
      <Grid item>
        <IgTypography>Choose Products</IgTypography>
      </Grid>
      <ChooseProducts
        index={index}
        payload={payload}
        dispatchPayload={dispatchPayload}
        setPhase={setPhase}
      />
    </Grid>
  );
};
